import { Gray, Main, White } from '@constants/color';
import { css } from '@emotion/react';

export const button = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '10px 32px',
  height: '60px',
  backgroundColor: Gray.Gray70,
  borderRadius: '6px',
  color: Gray.Gray50,
  fontSize: '24px',
  fontWeight: 700
});
export const focused = css({
  backgroundColor: Main.priBlue,
  color: White.White10
});
